import { render, staticRenderFns } from "./CogOutline.vue?vue&type=template&id=96fed70c"
import script from "./CogOutline.vue?vue&type=script&lang=js"
export * from "./CogOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports